import * as yup from 'yup';
import { SimplifiedHero } from '@web/components';
import { headlineVariantsSchema, linkSchema } from '../schemas';

export const component = SimplifiedHero;

export const schema = yup
  .object({
    heading: yup.string(),
    // SimplifiedHero has the level passed down to the SectionIntro component so we don't need the when block here
    headingVariants: headlineVariantsSchema(),
    description: yup.string(),
    link: linkSchema,
    backgroundColor: yup.string(),
    buttonVariant: yup.string(),
    level: yup.string(),
    eyebrow: yup.string(),
    typography: yup.string(),
    fontColor: yup.string(),
  })
  .transform(value => ({
    heading: value.heading,
    headingVariants: value.headline_variants,
    description: value.description,
    link: value.link?.[0],
    backgroundColor: value.backgroundColor || undefined,
    buttonVariant: value.button_variant || undefined,
    level: value.level,
    eyebrow: value.eyebrow,
    typography: value.typography || 'heading2',
    fontColor: value.font_color || undefined,
  }));
